import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from '../modules/components/Section';
import Eyebrow from '../modules/components/Eyebrow';

const values = [
  {
    num: '01',
    title: '確かな品質',
    body: '熟練の技術と知識で、高品質なモノづくりを提供します。',
  },
  {
    num: '02',
    title: '地域の信頼',
    body: '昭和42年の創業以来、入間の地で実績を積み重ねてきました。',
  },
  {
    num: '03',
    title: '安心の価格',
    body: '確かな技術を、納得いただける価格でご提供します。',
  },
];

function ProductValues() {
  return (
    <Section bg="kinari">
      <Box sx={{ textAlign: 'center', mb: { xs: 6, sm: 9 } }}>
        <Eyebrow>Our Values</Eyebrow>
        <Typography variant="h2" component="h2">
          飯田建築が大切にしていること
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
          gap: { xs: 5, sm: 7 },
        }}
      >
        {values.map((item) => (
          <Box key={item.num}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mb: 3,
                fontFamily: "'Noto Serif JP', serif",
                fontSize: 15,
                letterSpacing: '.2em',
                color: 'green',
                '&::after': { content: '""', flex: 1, height: '1px', bgcolor: 'line' },
              }}
            >
              {item.num}
            </Box>
            <Typography variant="h3" component="h3" sx={{ mb: 1.75 }}>
              {item.title}
            </Typography>
            <Typography sx={{ fontSize: 15, color: 'text.secondary' }}>{item.body}</Typography>
          </Box>
        ))}
      </Box>
    </Section>
  );
}

export default ProductValues;
